export const localizedPath = (path: string, lang: string) => {
  return lang === 'ja' ? path : `/${lang}${path}`
}
